var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnsibleColoredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-97.62 -147.24 64 64",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-33.62-115.24c0 17.674-14.326 32-32 32s-32-14.326-32-32 14.328-32 32-32 32 14.328 32 32",
    fill: "#ee0100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-65.08-127.692l8.28 20.438-12.508-9.853zm14.7 25.147L-63.108-133.2c-.364-.884-1.1-1.352-1.973-1.352s-1.664.468-2.028 1.352L-81.1-99.576h4.783l5.534-13.863 16.515 13.343c.664.537 1.144.78 1.767.78 1.248 0 2.338-.936 2.338-2.286 0-.22-.078-.57-.218-.944z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnsibleColoredIcon);
export default __webpack_public_path__ + "static/media/Ansible-colored-icon.d0d33cfd19b3fae5b72d82e744cd0e0d.svg";
export { ForwardRef as ReactComponent };